import React, { FC, LegacyRef } from 'react'
import { SetNavElement } from 'Src/hooks/useNav'
import {
	AccordionComponent,
	BtnComponent,
	FormNavigationItem,
	FormRowAdditionalElement,
	FormRowComponent,
	FormRowElement,
	i18n,
	UISizes,
} from 'LibNeo'
import { useSelector } from 'react-redux'
import { FormNames } from 'Constants/FormNames'
import { FieldNames } from 'Constants/FieldNames'
import { OutLinks } from 'Constants/OutLinks'
import { CONTOUR, getBaseUrl, getContour } from '@pp/axios'
import { intersection, WrappedFormUtilsExtended, downloadFile } from 'Helpers'
import {
	BgLimitRequestFull,
	bgLimitRequestSelector,
	fieldsByFormBlockLimit,
	getStatusByType,
	LimitRequestNav,
	WhiteBlock,
} from 'Pages/ibro'
import { BgLimitRequestUpload } from 'Pages/ibro/limitRequests/components/BgLimitRequestUpload'
import { formsSelectors } from 'Modules'

interface ComponentProps {
	setNavElement: SetNavElement
	blockItem: Required<FormNavigationItem>
}

export const Documents: FC<ComponentProps> = ({ setNavElement, blockItem }) => {
	const getForm = useSelector(formsSelectors.getGlobalForm)
	const form = getForm(FormNames.BROKER.LIMIT) as WrappedFormUtilsExtended
	const item = useSelector(bgLimitRequestSelector.selectCurrentLimitRequest) as BgLimitRequestFull
	const { required_fields = [] } = item
	const docFields = intersection(required_fields, fieldsByFormBlockLimit[LimitRequestNav.DOCUMENTS])

	const downLoadAnketa = () => {
		const isProdContour = getContour() === CONTOUR.PROD
		const anketaUrl = `${isProdContour ? '/public' : ''}${OutLinks.broker.anketa}`
		const url = `${getBaseUrl(true)}${anketaUrl}`
		downloadFile(url, url.split('/')?.pop() as string)
	}

	if (!docFields.length) return null

	return (
		<div ref={setNavElement(blockItem.idx) as LegacyRef<HTMLDivElement>}>
			<WhiteBlock>
				<AccordionComponent
					id={blockItem.title}
					titleText={blockItem.title}
					status={getStatusByType(blockItem.type)}
					titleSize={UISizes.BIG}
					noExpand
				>
					<>
						{docFields.map((fieldName) => (
							<FormRowComponent label={i18n(`broker.${fieldName}`)}>
								<FormRowElement>
									<BgLimitRequestUpload item={item} form={form} fieldName={fieldName} />
								</FormRowElement>
								{fieldName === FieldNames.ANKETAFSC ? (
									<FormRowAdditionalElement>
										<BtnComponent
											title="Скачать шаблон анкеты"
											size={UISizes.SMALL}
											outline
											icon="download"
											onClick={downLoadAnketa}
										/>
									</FormRowAdditionalElement>
								) : undefined}
							</FormRowComponent>
						))}

						<FormRowComponent label={i18n(`broker.${FieldNames.OTHERDOCS}`)}>
							<FormRowElement>
								<BgLimitRequestUpload item={item} form={form} fieldName={FieldNames.OTHERDOCS} />
							</FormRowElement>
						</FormRowComponent>
					</>
				</AccordionComponent>
			</WhiteBlock>
		</div>
	)
}
